/* eslint-disable no-unused-vars */
const mediaStreamSource = {}
const audioContext = {}
const meter = {}
const rafID = {}
const merger1 = {}
const merger2 = {}
const pannerLeft = {}
const pannerRight = {}
const splitter = {}
const inputNode = {}
const gainNodeLeft = {}
const gainNodeRight = {}
const percentageLeft = {}
const percentageRight = {}
const hasResumeAudio = []// 已经Resume()的audio
const currentCreateArr = [] // 当前已经使用audiocontext创建了对象的
const isHadTimer = false
const lastCallbackTimes = {}
window.audioContextDebug = false

// AudioWorklet processor code — 与 Audio Mixer 保持一致
// 参考: AudioMixer-Frontend/src/assets/js/audioContext.js
const VOLUME_METER_WORKLET_CODE = `
class VolumeMeterProcessor extends AudioWorkletProcessor {
  constructor(options) {
    super()
    const params = (options && options.processorOptions) || {}
    this.clipLevel = params.clipLevel || 0.98
    this.averaging = params.averaging || 0.99
    this.volume = [0, 0]
  }

  process(inputs) {
    const input = inputs[0]
    if (!input || !input.length) return true
    for (let i = 0; i < input.length && i < 2; i++) {
      const buf = input[i]
      const bufLength = buf.length
      let sum
      let x
      let clip = false
      for (let j = 0; j < bufLength; j++) {
        sum = 0
        x = buf[j]
        if (Math.abs(x) >= this.clipLevel) {
          clip = true
        }
        sum += x * x
      }
      const rms = Math.sqrt(sum / 256)
      this.volume[i] = Math.max(rms, this.volume[i] * this.averaging)
      if (clip) {
        this.port.postMessage({ type: 'clip' })
      }
    }
    this.port.postMessage({ type: 'volume', volume: [this.volume[0], this.volume[1]] })
    return true
  }
}
registerProcessor('volume-meter', VolumeMeterProcessor)
`
const workletRegistered = new WeakMap()

/**
 *
 * @param {stream} stream from webrtc or rtil
 * @param remoteKey get stream preview id
 * @param volumeBarIdArr canvas id array  index -0 => left canvas id;  index -1 => right canvas id
 */
async function audioTrack (stream, remoteKey, callBack, info) {
  console.info(30, stream, stream.getAudioTracks())
  if (!stream) return
  const audioStream = new MediaStream()
  audioStream.addTrack(stream.getAudioTracks()[0])

  // Fast path (Agora 断网重连 / 同一 slot 换 track)：沿用已有 AudioContext，
  // 只把内部 mediaStreamSource 换到新 track，避免重复创建 AudioContext
  // 参考: Audio Mixer 的 fast path 逻辑
  const existingCtx = audioContext[remoteKey]
  if (existingCtx && existingCtx.state !== 'closed' && inputNode[remoteKey]) {
    const oldSource = mediaStreamSource[remoteKey]
    if (oldSource) oldSource.disconnect()
    const newSource = existingCtx.createMediaStreamSource(audioStream)
    mediaStreamSource[remoteKey] = newSource
    newSource.connect(inputNode[remoteKey])
    if (meter[remoteKey]) newSource.connect(meter[remoteKey])
    return
  }

  // Slow path：首次建立或上一次已被关闭
  window.AudioContext = window.AudioContext || window.webkitAudioContext
  if (audioContext[remoteKey]) {
    closeAudioContext(remoteKey)
  }
  audioContext[remoteKey] = new AudioContext()
  mediaStreamSource[remoteKey] = audioContext[remoteKey].createMediaStreamSource(audioStream)

  merger1[remoteKey] = audioContext[remoteKey].createChannelMerger(2)
  merger2[remoteKey] = audioContext[remoteKey].createChannelMerger(2)
  inputNode[remoteKey] = audioContext[remoteKey].createGain()
  splitter[remoteKey] = audioContext[remoteKey].createChannelSplitter(2)

  const pannerOptions = { pan: 0 }
  if (typeof StereoPannerNode == 'undefined') return
  pannerLeft[remoteKey] = new StereoPannerNode(
    audioContext[remoteKey],
    pannerOptions
  )
  pannerRight[remoteKey] = new StereoPannerNode(
    audioContext[remoteKey],
    pannerOptions
  )
  mediaStreamSource[remoteKey].connect(inputNode[remoteKey])

  inputNode[remoteKey].connect(splitter[remoteKey])
  gainNodeLeft[remoteKey] = audioContext[remoteKey].createGain()
  gainNodeRight[remoteKey] = audioContext[remoteKey].createGain()

  splitter[remoteKey].connect(gainNodeLeft[remoteKey], 0)
  splitter[remoteKey].connect(gainNodeRight[remoteKey], 1)

  // 静音,将左右声道的声音置为0  取值范围为 0 - 1;
  gainNodeLeft[remoteKey].gain.setValueAtTime(0, audioContext[remoteKey].currentTime)
  gainNodeRight[remoteKey].gain.setValueAtTime(0, audioContext[remoteKey].currentTime)

  gainNodeLeft[remoteKey].connect(merger1[remoteKey], 0, 0)
  gainNodeRight[remoteKey].connect(merger2[remoteKey], 0, 1)

  merger1[remoteKey]
    .connect(pannerLeft[remoteKey])
    .connect(audioContext[remoteKey].destination)
  merger2[remoteKey]
    .connect(pannerRight[remoteKey])
    .connect(audioContext[remoteKey].destination)

  // AudioWorklet 需要异步加载，保存当前 context 引用防止并发替换
  window.audioContext = audioContext
  const currentCtx = audioContext[remoteKey]
  const meterResult = await createAudioMeter(currentCtx)
  // 如果 await 期间 context 被关闭或被另一次 audioTrack 调用替换，中止
  if (!meterResult || audioContext[remoteKey] !== currentCtx) return
  meter[remoteKey] = meterResult
  mediaStreamSource[remoteKey].connect(meter[remoteKey])
  audioContext[remoteKey].suspend()// suspend audiocontext  because of chrome not allowed audiocontext auto live
  drawLoop(remoteKey)
  drawLoop(remoteKey, callBack, info)
}

// 静音
function muteVolume (remoteKey, isMute) {
  if (!gainNodeLeft || !gainNodeLeft[remoteKey]) return
  if (isMute) {
    gainNodeLeft[remoteKey].gain.setValueAtTime(0, audioContext[remoteKey].currentTime)
    gainNodeRight[remoteKey].gain.setValueAtTime(0, audioContext[remoteKey].currentTime)
  } else {
    gainNodeLeft[remoteKey].gain.setValueAtTime(1, audioContext[remoteKey].currentTime)
    gainNodeRight[remoteKey].gain.setValueAtTime(1, audioContext[remoteKey].currentTime)
  }
}

// Restore audiocontext
function resumeAudio (remoteKey) {
  // if(hasResumeAudio.includes(remoteKey)) return; //已经resume()的key不在resume
  if (audioContext[remoteKey] && audioContext[remoteKey].state === 'suspended') {
    audioContext[remoteKey].resume()
    muteVolume(remoteKey, true)
    hasResumeAudio.push(remoteKey)
    if (window.audioContextDebug) console.log(remoteKey, audioContext[remoteKey])
  }
}

function drawLoop (remoteKey, callBack, info) {
  const rawLeft = meter[remoteKey] ? meter[remoteKey].volume[0] : 0
  const rawRight = meter[remoteKey] ? meter[remoteKey].volume[1] : 0

  // 保留旧的缩放值给 callback 兼容
  let floorValue = Math.pow(10, (500 + 100) / 100) * 0.04093171969
  percentageLeft[remoteKey] = Math.floor(floorValue)
  const left = rawLeft * percentageLeft[remoteKey]
  let volumeLeft = left / 100
  if (volumeLeft.toString().indexOf('e') > -1) {
    volumeLeft = 0
  }

  if (!info || !info.notNeedAnimation) {
    canvasDrap(remoteKey + 'Left', rawLeft)
    canvasDrap(remoteKey + 'Right', rawRight)
  }
  window.audioContext = audioContext
  rafID[remoteKey] = window.requestAnimationFrame(() => drawLoop(remoteKey, callBack))
  if (callBack && typeof callBack === 'function') callBack(volumeLeft, audioContext[remoteKey], rafID[remoteKey])
}

// volume-meter — 使用 AudioWorkletNode 替代已废弃的 ScriptProcessorNode
// 与 Audio Mixer (AudioMixer-Frontend) 保持一致
async function createAudioMeter (audioCtx, clipLevel, averaging, clipLag) {
  if (!workletRegistered.get(audioCtx)) {
    const blob = new Blob([VOLUME_METER_WORKLET_CODE], { type: 'application/javascript' })
    const url = URL.createObjectURL(blob)
    try {
      await audioCtx.audioWorklet.addModule(url)
    } finally {
      URL.revokeObjectURL(url)
    }
    workletRegistered.set(audioCtx, true)
  }

  if (audioCtx.state === 'closed') return null

  const node = new AudioWorkletNode(audioCtx, 'volume-meter', {
    processorOptions: {
      clipLevel: clipLevel || 0.98,
      averaging: averaging || 0.99
    }
  })
  node.clipping = false
  node.lastClip = 0
  node.volume = [0, 0]
  node.clipLevel = clipLevel || 0.98
  node.averaging = averaging || 0.99
  node.clipLag = clipLag || 750

  node.port.onmessage = (e) => {
    if (e.data.type === 'volume') {
      node.volume = e.data.volume
    } else if (e.data.type === 'clip') {
      node.clipping = true
      node.lastClip = window.performance.now()
    }
  }

  node.connect(audioCtx.destination)
  node.checkClipping = function () {
    if (!this.clipping) return false
    if (this.lastClip + this.clipLag < window.performance.now()) { this.clipping = false }
    return this.clipping
  }
  node.shutdown = function () {
    this.disconnect()
    this.port.close()
  }
  return node
}

// dB 渲染配置 — 与 AM VolumeBar.vue 对齐
// VolumeBar.vue: dBVal = 20 * Math.log10(val * 16)
const DB_MIN = -60
const DB_MAX = 12
const DB_RANGE = DB_MAX - DB_MIN
const WORKLET_COMPENSATION = 16

function linearToDb (linear) {
  const corrected = linear * WORKLET_COMPENSATION
  if (corrected < 0.000001) return DB_MIN
  const db = 20 * Math.log10(corrected)
  return Math.max(DB_MIN, Math.min(DB_MAX, db))
}

function canvasDrap (id, linearVolume) {
  const canvas = document.getElementsByClassName(id)
  if (!canvas || canvas.length === 0) return

  const dB = linearToDb(linearVolume)
  const normalized = (dB - DB_MIN) / DB_RANGE // 0 ~ 1

  for (let i = 0; i < canvas.length; i++) {
    const currentCanvas = canvas[i]
    const w = currentCanvas.width
    const h = currentCanvas.height
    const ctx = currentCanvas.getContext('2d')

    currentCanvas.style.transform = ''
    ctx.clearRect(0, 0, w, h)

    // 渐变色：绿(底) → 黄 → 红(顶)
    const gradient = ctx.createLinearGradient(0, h, 0, 0)
    gradient.addColorStop(0, '#5DC045')
    gradient.addColorStop(0.6, '#5DC045')
    gradient.addColorStop(0.8, '#F1D737')
    gradient.addColorStop(1, '#F6445A')

    const barH = normalized * h
    ctx.fillStyle = gradient
    ctx.fillRect(0, h - barH, w, barH)
  }
}

function resumeAudioBar () {
  const audioContext = window.audioContext || {}
  if (!audioContext) return
  Object.keys(audioContext).map(key => {
    console.log(2222222222)
    if (audioContext[key] && audioContext[key].state === 'suspended') {
      audioContext[key].resume()
      if (window.audioContextDebug) console.log('*****resume****', key + ' : ' + audioContext[key].state)
    }
  })
  if (window.audioContextDebug) console.log('current audioContext status: ', audioContext)
}

function closeAudioContext (remoteKey) {
  if (audioContext[remoteKey]) {
    if (rafID[remoteKey]) {
      cancelAnimationFrame(rafID[remoteKey])
      delete rafID[remoteKey]
    }
    if (meter[remoteKey]) {
      meter[remoteKey].shutdown()
      delete meter[remoteKey]
    }
    audioContext[remoteKey].suspend()
    audioContext[remoteKey].destination.disconnect()
    audioContext[remoteKey].close()
  }
}

/*
* audioTrack => 实例化audiocontext
* muteVolume => 静音与开音
* resumeAudio => 恢复挂起的audiocontext.
* */
export const audioContextObj = {
  audioTrack,
  muteVolume,
  resumeAudio,
  resumeAudioBar,
  closeAudioContext
}
